/**
 * ログイン画面。2 アプリで同じものを使う。
 *
 * 入力欄は持たない。ID とパスワードを受け取るのは認可サーバーの画面の役目で、
 * こちらは「認可へ行く」ボタンと、失敗したときの理由だけを持つ。
 */

import type { ReactNode } from "react";

import { Button } from "./primitives";
import { useAuthState, useSession } from "../auth/AuthProvider";

export function LoginScreen({
  appName,
  description,
  returnTo = "/",
  extra,
}: {
  appName: string;
  description: string;
  returnTo?: string;
  /** 見出しの横に置くもの（画面のヘルプなど）。無ければ何も出さない */
  extra?: ReactNode;
}) {
  const session = useSession();
  const state = useAuthState();
  const busy =
    state.status === "authorizing" || state.status === "initializing";

  return (
    <div className="vd-login">
      <div className="vd-login-card">
        <span className="vd-row">
          <h1>{appName}</h1>
          {extra}
        </span>
        <p>{description}</p>
        {state.error === null ? null : (
          <p className="vd-notice vd-notice--error" role="alert">
            {state.error}
          </p>
        )}
        <Button
          variant="primary"
          size="large"
          disabled={busy}
          style={{ width: "100%" }}
          onClick={() => {
            void session.login({ returnTo });
          }}
        >
          {busy ? "認証しています" : "ログイン"}
        </Button>
      </div>
    </div>
  );
}
